export const environment = {
  production: true,
  apiProtocol: "https://",
  apiDomain: "api.flowmaps.com",
};
